import { useEffect, useState, useCallback } from "react";

// Subscribes a component to the custom "pib-storage" event so localStorage
// changes (including resets) reflect immediately in the UI within the tab.
export default function useStorageSync(readFn, deps = []) {
  const [value, setValue] = useState(readFn);

  const refresh = useCallback(() => setValue(readFn()), deps); // eslint-disable-line

  useEffect(() => {
    refresh();
    const handler = () => refresh();
    window.addEventListener("pib-storage", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("pib-storage", handler);
      window.removeEventListener("storage", handler);
    };
  }, [refresh]);

  return [value, refresh];
}
